/*
 * Copyright (c) 2024-2025. The content provided herein is protected by copyright law. Unauthorized use, reproduction, or distribution of this material without proper licensing, knowledge, and contract agreement from the author is strictly prohibited. Any infringement of these rights may result in legal action. For inquiries regarding the use of this content, please contact the author for proper authorization and agreement.
 */

import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { Hall } from 'types/entities/Hall'
import { Language } from 'types/entities/Language'
import { SESSION_RESET } from '../session/SessionActionTypes'
import { HallOpeningHour } from 'types/entities/HallOpeningHour'
import { HallStateResponse } from 'types/responses/HallStateResponse'

export interface HallState {
    hall: Hall | null
    hallsList: Hall[] | null
    openingHours: HallOpeningHour[]
}

const initialState: HallState = {
    hall: null,
    hallsList: null,
    openingHours: [],
}

const hallSlice = createSlice({
    name: 'hall',
    initialState,
    reducers: {
        setHall(state, action: PayloadAction<HallStateResponse>) {
            state.hall = action.payload.hall
            state.openingHours = action.payload.openingHours
        },
        setHallsList(state, action: PayloadAction<Hall[]>) {
            state.hallsList = action.payload
        },
        setLanguage(state, action: PayloadAction<Language>) {
            if (state.hall) {
                state.hall.language = action.payload
            }
        },
        resetState: () => initialState,
    },
})

export const { setHall, setHallsList, setLanguage, resetState } = hallSlice.actions
export default hallSlice.reducer
